<template>
  <a-modal :title="$t('investorList.tzrmx')" :width="1200" :visible="visible" :footer="null" @cancel="handleCancel">
    <div class="investor-detail-container">
      <div class="search-form">
        <a-form layout="inline">
          <a-form-item>
            <a-input-group compact>
              <a-select v-model="queryParam.searchType" style="width: 170px">
                <a-select-option value="investUserName">{{ $t('investorList.tzrxm') }}</a-select-option>
                <a-select-option value="mobile">{{ $t('investorList.tzrzh') }}</a-select-option>
              </a-select>
              <a-input v-model="queryParam.searchValue" style="width: 180px" :placeholder="$t('enter')" />
            </a-input-group>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="handleSearch">{{ $t('search') }}</a-button>
          </a-form-item>
        </a-form>
      </div>

      <a-table
        bordered
        :columns="columns"
        :data-source="dataSource"
        :pagination="pagination"
        :loading="loading"
        @change="handleTableChange"
        rowKey="id"
        :scroll="{ x: 900 }"
      >
        <span slot="investAmount" slot-scope="text">
          {{ text | FenToDong }}
        </span>
        <span slot="mobile" slot-scope="text">
          {{ desensitizeMobile(text) }}
        </span>
        <span slot="type" slot-scope="text">
          {{ investorTypeFilter(text) }}
        </span>
        <span slot="proportion" slot-scope="text">
          {{ formatProportion(text) }}
        </span>
      </a-table>
    </div>
  </a-modal>
</template>

<script>
import { getInvestorList1 } from '@/webpublicapi/vietnamBackstage'

export default {
  name: 'InvestorDetailModal',
  data() {
    return {
      visible: false,
      loading: false,
      investId: undefined,
      queryParam: {
        searchType: 'investUserName',
        searchValue: '',
      },
      dataSource: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showTotal: (total) => `${this.$t('components.total')} ${total} ${this.$t('components.items')}`,
      },
      columns: [
        { title: this.$t('investorList.tzrxm'), dataIndex: 'name', width: 150 },
        {
          title: this.$t('investorList.tzrzh'),
          dataIndex: 'mobile',
          scopedSlots: { customRender: 'mobile' },
          width: 180,
        },
        {
          title: this.$t('investorList.tzrlx'),
          dataIndex: 'type',
          scopedSlots: { customRender: 'type' },
          width: 120,
        },
        {
          title: this.$t('investorList.tzje'),
          dataIndex: 'orderAmount',
          scopedSlots: { customRender: 'investAmount' },
          width: 150,
        },
        {
          title: this.$t('investorList.tzzb'),
          dataIndex: 'proportion',
          scopedSlots: { customRender: 'proportion' },
          width: 120,
        },
      ],
    }
  },
  methods: {
    show(investId) {
      this.visible = true
      this.investId = investId
      this.pagination.current = 1
      this.queryParam.searchValue = ''
      this.loadData()
    },
    handleCancel() {
      this.visible = false
    },
    handleSearch() {
      this.pagination.current = 1
      this.loadData()
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.loadData()
    },
    investorTypeFilter(type) {
      const map = {
        1: this.$t('investorList.gr'),
        10: this.$t('investorList.qy'),
      }
      return map[type] || '-'
    },
    desensitizeMobile(mobile) {
      if (!mobile) return '-'
      if (mobile.length <= 7) return mobile
      return mobile.substring(0, 3) + '****' + mobile.substring(mobile.length - 4)
    },
    formatProportion(value) {
      if (value === null || value === undefined || value === '') return '-'
      return (Number(value) * 100).toFixed(6) + '%'
    },
    loadData() {
      if (!this.investId) {
        this.dataSource = []
        this.pagination.total = 0
        return
      }

      this.loading = true
      const params = {
        pageNo: this.pagination.current,
        pageSize: this.pagination.pageSize,
        investId: this.investId,
      }

      if (this.queryParam.searchValue) {
        if (this.queryParam.searchType === 'investUserName') {
          params.investorName = this.queryParam.searchValue
        } else if (this.queryParam.searchType === 'mobile') {
          params.investorMobile = this.queryParam.searchValue
        }
      }

      getInvestorList1(params)
        .then((res) => {
          if (res.success && res.respData) {
            const { records, total, current } = res.respData
            this.dataSource = records || []
            this.pagination.total = total || 0
            this.pagination.current = current || 1
          } else {
            this.dataSource = []
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style lang="less" scoped>
.investor-detail-container {
  padding: 10px 20px;

  .search-form {
    margin-bottom: 16px;
  }
}
</style>
